// Minimal SSE parsing for streamed chat responses.
//
// The one rule that matters: only COMPLETE events (terminated by a blank line)
// are emitted; the unterminated tail is returned for the caller to keep in its
// buffer. Emitting the tail as it grows — the previous behaviour — appended
// every partial snapshot of an event to the transcript, duplicating the answer
// a little more on every network chunk ("OfOfcourse. Here are …").
//
// Per the SSE spec, exactly one leading space after "data:" is stripped and
// multi-line data joins with newlines; data is otherwise untouched, because for
// text chunks the spaces at chunk boundaries are real content.

function parseBlock(block) {
  let event = null;
  const data = [];
  for (const line of block.split("\n")) {
    if (line.startsWith("event:")) {
      event = line.slice(6).trim();
    } else if (line.startsWith("data:")) {
      let v = line.slice(5);
      if (v.startsWith(" ")) v = v.slice(1);
      data.push(v);
    }
  }
  return event ? { event, data: data.join("\n") } : null;
}

// Returns { events, remainder }: parse everything up to the last blank-line
// terminator; hand the unterminated tail back for the next read.
export function parseSSEStream(buffer) {
  const text = String(buffer || "").replace(/\r\n/g, "\n");
  const cut = text.lastIndexOf("\n\n");
  if (cut < 0) return { events: [], remainder: text };
  const events = [];
  for (const block of text.slice(0, cut).split("\n\n")) {
    const evt = parseBlock(block);
    if (evt) events.push(evt);
  }
  return { events, remainder: text.slice(cut + 2) };
}

// At end-of-stream a final event may lack its terminator; parse it once.
export function parseSSEFinal(buffer) {
  const evt = parseBlock(String(buffer || "").replace(/\r\n/g, "\n"));
  return evt ? [evt] : [];
}
